import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { ColorTokens, PageLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { useEntity, SiteHeaderLayout, SliceLayoutBoundary, SiteHeaderProvider, EntityTitleHeader } from '@shapeable/ui';
import { RegionLayoutGrid } from '../entities/region-grid-layout';
import { APP_CHROME, DARK_BLUE_OVERLAY, OCEAN_TIEL } from '../../theme';
import { BANNER_KNOWLEDGE_HUB } from '../../data';


// -------- Child Component Props -------->

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`

  `,
});

const BodyStyles = breakpoints({
  base: css`
  `,
});

const GridStyles = breakpoints({
  base: css`
    padding-top: ${theme.UNIT(8)};
    background-color: ${theme.COLOR(APP_CHROME)};
  `,
});


// -------- Components -------->

const My = {
  Container: styled.div`${ContainerStyles}`,
    Body: styled.div`${BodyStyles}`,
    Grid: styled(RegionLayoutGrid)`${GridStyles}`,

};

export const PageLayoutRegions: PageLayoutComponent = (props) => {
  const { className, slices } = props;
  const entity = useEntity(props.entity);

  const headerColors: ColorTokens.TextBackground = {
    text: 'light',
  };

  return (
      <SiteHeaderProvider value={{
        variant: 'overlay',
      }}>
      <My.Container className={className}>
        <EntityTitleHeader colors={headerColors} overlayColor={DARK_BLUE_OVERLAY} backgroundImage={BANNER_KNOWLEDGE_HUB} entity={entity} />
        <My.Body>
          {/* {slices} */}
          {/* <SliceLayoutBoundary boundary='content' verticalPadding='none'> */}
            <My.Grid />
          {/* </SliceLayoutBoundary> */}
        </My.Body>
      </My.Container> 
      </SiteHeaderProvider>
  );
};

